import gql from 'graphql-tag'

export default gql`
    mutation updateFreeDay($id: ID!, $fields: FreeDayInput!) {
        cashAssist {
            updateFreeDay(id: $id, fields: $fields) {
                id
                date
                day
                name
                cashRegisterId
            }
        }
    }
`
